import React, { useState } from "react";
import { X } from "lucide-react";
import { memberLogin, memberRegister, apiError } from "../lib/member";

const input = "w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm outline-none focus:border-[var(--p-teal)] focus:ring-2 focus:ring-[var(--p-teal)]/15";

export default function MemberAuthModal({ initialMode = "join", onClose, onDone }) {
  const [mode, setMode] = useState(initialMode);
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const m = mode === "join" ? await memberRegister(form) : await memberLogin(form.email, form.password);
      onDone(m);
    } catch (err) { setError(apiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4" onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} data-testid="member-auth-modal" className="w-full max-w-md rounded-3xl bg-white p-6 shadow-2xl">
        <div className="flex items-center justify-between">
          <h3 className="font-portal text-2xl font-extrabold text-[var(--p-ink)]">{mode === "join" ? "Join the Loyalty Club" : "Welcome back"}</h3>
          <button type="button" onClick={onClose} aria-label="Close" className="text-slate-400 hover:text-slate-700"><X size={22} /></button>
        </div>
        <p className="mt-1 text-sm text-slate-500">{mode === "join" ? "Free for everyone. Newspaper subscribers unlock extra perks automatically." : "Sign in to claim offers and see your member card."}</p>
        <div className="mt-5 space-y-3">
          {mode === "join" && <input data-testid="member-name-input" placeholder="Full name" value={form.name} onChange={set("name")} className={input} required />}
          <input data-testid="member-email-input" type="email" placeholder="Email (use the one on your subscription)" value={form.email} onChange={set("email")} className={input} required />
          {mode === "join" && <input data-testid="member-phone-input" placeholder="Mobile phone (optional)" value={form.phone} onChange={set("phone")} className={input} />}
          <input data-testid="member-password-input" type="password" placeholder={mode === "join" ? "Create a password (8+ characters)" : "Password"} value={form.password} onChange={set("password")} className={input} required />
        </div>
        {error && <p data-testid="member-auth-error" className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
        <button type="submit" disabled={busy} data-testid="member-auth-submit" className="mt-5 w-full rounded-full bg-[var(--p-teal)] py-3 text-sm font-bold text-white transition-colors hover:bg-[var(--p-teal-bright)] disabled:opacity-60">
          {busy ? "Please wait…" : mode === "join" ? "Create my free account" : "Sign in"}
        </button>
        <button type="button" data-testid="member-auth-toggle" onClick={() => { setMode(mode === "join" ? "login" : "join"); setError(""); }} className="mt-3 w-full text-center text-sm font-semibold text-[var(--p-teal)] hover:underline">
          {mode === "join" ? "Already a member? Sign in" : "New here? Join free"}
        </button>
      </form>
    </div>
  );
}
